<template>
  <Card>
    <template #content>
      <div style="display: flex; justify-content: space-around;">
        <ul class="timeline">
          <li class="li " v-for="situacao in eventos" :class="situacao.finalizado ? 'complete' : ''" v-bind:key="situacao.cod">
            <div style="display: flex;align-items: stretch;flex-direction: column;justify-content: space-evenly;">
              <div class="timestamp">
                  <span :class="situacao.icone"></span>
              </div>
              <div class="status " :class="situacao.finalizado ? 'complete' : ''">
                <h5> {{situacao.descricao}} </h5>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <!-- <div style="flex-direction: row; display: flex;">

        <div :class="processo.estadoSelecao.cod >= 0 ? 'timeline' : 'timeline2'">
          <div class="left justify-content-end" :class="processo.estadoSelecao.cod >= 0 ? 'container' : 'container2'">
            <div class="content">
              <Button style="color:rgb(100, 100, 100); font-size: 20px;" iconPos="right" type="button" label="Em andamento" icon="pi pi-spinner pi-spin" class="button p-button-text"/>
            </div>
          </div>
        </div>


        <div class="timeline"></div>
                   <div class=" right container">
            <div class="content">
              <Button style="color:rgb(100, 100, 100); font-size: 20px;" type="button" label="Local de prova distribuído" icon="pi pi-map-marker" class="button p-button-text"   />
            </div>
          </div>
        </div>

        <div :class="processo.estadoSelecao.cod >= 2 ? 'timeline' : 'timeline2'">
          <div class=" left" :class="processo.estadoSelecao.cod >= 2 ? 'container' : 'container2'">
            <div class="content">
              <Button iconPos="right" style="color:rgb(100, 100, 100); font-size: 20px;" type="button" label="Cartão de confirmação liberado" icon="pi pi-unlock" class="button p-button-text"/>
            </div>
          </div>
        </div>

        <div :class="processo.estadoSelecao.cod >= 3 ? 'timeline' : 'timeline2'">
          <div class=" right" :class="processo.estadoSelecao.cod >= 3 ? 'container' : 'container2'">
            <div class="content flex justify-content-start    ">
              <Button style="color:rgb(100, 100, 100); font-size: 20px;" type="button" label="Resultado do processo gerado" icon="pi pi-align-justify" class="button p-button-text"   />
            </div>
          </div>
        </div>
        <div :class="processo.estadoSelecao.cod >= 4 ? 'timeline' : 'timeline2'">
          <div
            class=" left"
            :class="processo.estadoSelecao.cod >= 4 ? 'container' : 'container2'"
          >

            <div class="content flex justify-content-end    ">

              <Button  iconPos="right" style="color:rgb(100, 100, 100); font-size: 20px;" type="button" label="Finalizado" icon="pi pi-check-square" class="button p-button-text"   />



            </div>
          </div>
        </div>
      </div> -->
    </template>
  </Card>
</template>

<script>
import moment from "moment";
import EstadoSelecaoService from "../service/EstadoSelecaoService";

export default {
  components: {},
  props: ["processo"],

  data() {
    return {
      eventos: [],
      events1: [],
      listaEstado: [],
      habilitaInscricoes: false,
      estadoSelecaoService: null,
    };
  },

  inscricaoService: null,
  estadoInscricaoService: null,

  created() {
    this.estadoSelecaoService = new EstadoSelecaoService();
  },

  async mounted() {
    this.estadoSelecaoService.getEstadosSelecao()
        .then( data => {
          this.listaEstado = data;
          this.abastecerEventos();
      });
  },

  watch: {
  	processo() {
      this.abastecerEventos();
  	}
  },

  methods: {
    adicionarEvento( codEstado, icone) {
      this.listaEstado.filter( e => e.cod == codEstado)
                  .forEach(situacao => {
                      this.eventos.push(
                        {
                          descricao: situacao.descricao,
                          finalizado: this.processo.estadoSelecao.sequencia >= situacao.sequencia,
                          icone: icone
                        }
                      );
                  });
    },
    abastecerEventos() {
      this.eventos = [];
      this.adicionarEvento(0, "pi pi-spinner pi-spin");
      this.adicionarEvento(1, "pi pi-map-marker");
      this.adicionarEvento(2, "pi pi-unlock");
      this.adicionarEvento(3, "pi pi-align-justify");
      this.adicionarEvento(4, "pi pi-check-square");
    },
    inscricoesEmAberto(data_fim_inscricao) {
      //Formato esperado YYYY-MM-DD
      //2022-01-31T23:59:59

      var fimInscricaoDate = moment(
        data_fim_inscricao,
        "DD-MM-YYYY HH:mm:ss"
      ).format("MM/DD/YYYY  HH:mm:ss");
      fimInscricaoDate = new Date(fimInscricaoDate);
      const dataAtual = new Date();

      if (fimInscricaoDate.getTime() > dataAtual.getTime()) {
        console.log(`inscricoesEmAberto: Sim`);
        return false;
      } else {
        console.log(`inscricoesEmAberto: Não`);
        return true;
      }
    },
  },
};
</script>

<style scoped>

.timeline {
  list-style-type: none;
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.li {
  transition: all 200ms ease-in;
}

.timestamp {
  margin-bottom: 21px;
  padding: 0px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 100;
}

.timestamp.button {
  margin-top: 21px;
  margin-bottom: 0px;
}

.status {
  padding: 0px 30px;
  display: flex;
  justify-content: center;
  border-top: 2px solid #D6DCE0;
  position: relative;
  transition: all 200ms ease-in;
}

.status h5 {
  margin: 10px 0px;
  font-weight: 500;
  text-align: center;
}

.status:before {
  content: "";
  width: 25px;
  height: 25px;
  background-color: white;
  border-radius: 25px;
  border: 1px solid #ddd;
  position: absolute;
  top: -15px;
  left: 42%;
  transition: all 200ms ease-in;
}

.li.complete .status {
  border-top: 2px solid #66DC71;
}

.li.complete .status.button{
  border-bottom: 2px solid #66DC71;
  border-top: none;
}

.li.complete .status:before {
  background-color: #66DC71;
  border: none;
  transition: all 200ms ease-in;
}

.li.complete .status.button:before {
  background-color: #66DC71;
  border: none;
  transition: all 200ms ease-in;
  top: 30px;
}

.li.complete .status h4 {
  color: #66DC71;
}

.aguarde {
  width: 130px;
  height: 130px;
  text-align: center;
}

* {
  box-sizing: border-box;
}

/* Set a background color */
body {
  background-color: #474e5d;
  font-family: Helvetica, sans-serif;
}

h5 {
  color: #39af0ae1;
}

/* The actual timeline (the vertical ruler) */
/* .timeline {
  position: relative;
  max-width: 70%;
  margin: 0 auto;
  flex-direction: row;
  display: flex;
} */
.timeline2 {
  position: relative;
  max-width: 70%;
  margin: 0 auto;
  flex-direction: row;
  display: flex;
}

/* The actual timeline (the vertical ruler) */
/* .timeline::after {
  content: "";
  position: relative;
  width: 3px;
  background-color: rgb(17, 219, 78);
  top: 0;
  bottom: 0;
  transform: rotate(90deg);
} */

.timeline2::after {
  content: "";
  position: relative;
  width: 3px;
  background-color: rgb(209, 228, 215);
  top: 0;
  bottom: 0;
  /* left: 50%; */
  /* margin-left: -3px; */
  transform: rotate(90deg);
}

/* Container around content */
.container {
  padding: 0px 0px;
  position: relative;
  background-color: inherit;
  width: 50%;

}

.container2 {
  padding: 0px 0px;
  position: relative;
  background-color: inherit;
  width: 50%;
}
/* The circles on the timeline */
.container::after {
  content: "";
  position: absolute;
  width: 15px;
  height: 15px;
  /* right: -10px; */
  background-color: rgb(231, 101, 15);
  border: 4px solid #d3cdb8;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}
.container2::after {
  content: "";
  position: absolute;
  width: 15px;
  height: 15px;
  /* right: -10px; */
  background-color: rgb(255, 255, 255);
  border: 4px solid #d3cdb8;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}

/* Place the container to the left */
.left {
  left: 0;
}

/* Place the container to the right */
.right {
  left: 50%;
}

/* Add arrows to the left container (pointing right) */
.left::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  right: 30px;
  border: medium solid white;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent white;
}

/* Add arrows to the right container (pointing left) */
.right::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  left: 30px;
  border: medium solid white;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
}

/* Fix the circle for containers on the right side */
.right::after {
  left: -12px;
}

/* The actual content */
.content {
  padding: 25px 10px;
  background-color: white;
  position: relative;
  border-radius: 6px;
}

/* Media queries - Responsive timeline on screens less than 600px wide */
@media screen and (max-width: 600px) {
  /* Place the timelime to the left */
  .timeline::after {
    left: 0;
  }

  .timeline2::after {
    left: 31px;
  }

  /* Full-width containers */
  .container {
    width: 100%;
    padding-left: 0px;
    padding-right: 0px;
  }

  .container2 {
    width: 100%;
    padding-left: 70px;
    padding-right: 25px;
  }

  /* Make sure that all arrows are pointing leftwards */
  .container::before {
    left: 60px;
    border: medium solid white;
    border-width: 10px 10px 10px 0;
    border-color: transparent white transparent transparent;
  }

  .container2::before {
    left: 60px;
    border: medium solid white;
    border-width: 10px 10px 10px 0;
    border-color: transparent white transparent transparent;
  }

  /* Make sure all circles are at the same spot */
  .left::after,
  .right::after {
    left: 15px;
  }

  /* Make all right containers behave like the left ones */
  .right {
    left: 0%;
  }
  .left {
    left: 0%;
  }
.button {
  background-color: #4CAF50;
  border: none;
  color: rgb(117, 67, 67);
  padding: 5px 5px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 0px 0px;
  cursor: pointer;
  width: auto;
  /* transform: rotate(90deg) !important; */
}

}
</style>
